// Currency conversion constants for AMHAS pricing
// Based on exchange rates as of December 2025

export const PRICING = {
  USD: 28,
  CFA: 15820, // ~565 XOF per USD
  GMD: 2030,  // ~72.5 GMD per USD
};

export const EARLY_DISCOUNT_CFA = 1200;

// Format price display
export const formatPrice = (currency = 'USD') => {
  switch (currency.toUpperCase()) {
    case 'CFA':
      return `${PRICING.CFA.toLocaleString()} CFA`;
    case 'GMD':
      return `${PRICING.GMD.toLocaleString()} GMD`;
    case 'USD':
    default:
      return `$${PRICING.USD} USD`;
  }
};

// Get all price formats
export const getAllPriceFormats = () => {
  return {
    usd: formatPrice('USD'),
    cfa: formatPrice('CFA'),
    gmd: formatPrice('GMD'),
  };
};

// Get price with early discount
export const getPriceWithEarlyDiscount = (currency = 'CFA') => {
  if (currency.toUpperCase() === 'CFA') {
    const discounted = PRICING.CFA - EARLY_DISCOUNT_CFA;
    return `${discounted.toLocaleString()} CFA`;
  }
  // For other currencies, calculate proportionally
  const discountRatio = EARLY_DISCOUNT_CFA / PRICING.CFA;
  if (currency.toUpperCase() === 'GMD') {
    const discounted = PRICING.GMD - (PRICING.GMD * discountRatio);
    return `${Math.round(discounted).toLocaleString()} GMD`;
  }
  const discounted = PRICING.USD - (PRICING.USD * discountRatio);
  return `$${discounted.toFixed(2)} USD`;
};

// Format monthly price display (yearly price / 12)
export const formatMonthlyPrice = (currency = 'USD') => {
  switch (currency.toUpperCase()) {
    case 'CFA':
      const monthlyCFA = Math.round(PRICING.CFA / 12);
      return `${monthlyCFA.toLocaleString()} CFA`;
    case 'GMD':
      const monthlyGMD = Math.round(PRICING.GMD / 12);
      return `${monthlyGMD.toLocaleString()} GMD`;
    case 'USD':
    default:
      const monthlyUSD = (PRICING.USD / 12).toFixed(2);
      return `$${monthlyUSD} USD`;
  }
};

// Get monthly price with early discount (yearly discounted price / 12)
export const getMonthlyPriceWithEarlyDiscount = (currency = 'CFA') => {
  if (currency.toUpperCase() === 'CFA') {
    const discounted = PRICING.CFA - EARLY_DISCOUNT_CFA;
    const monthly = Math.round(discounted / 12);
    return `${monthly.toLocaleString()} CFA`;
  }
  // For other currencies, calculate proportionally
  const discountRatio = EARLY_DISCOUNT_CFA / PRICING.CFA;
  if (currency.toUpperCase() === 'GMD') {
    const discounted = PRICING.GMD - (PRICING.GMD * discountRatio);
    const monthly = Math.round(discounted / 12);
    return `${monthly.toLocaleString()} GMD`;
  }
  const discounted = PRICING.USD - (PRICING.USD * discountRatio);
  const monthly = (discounted / 12).toFixed(2);
  return `$${monthly} USD`;
};

// Get all monthly price formats
export const getAllMonthlyPriceFormats = () => {
  return {
    usd: formatMonthlyPrice('USD'),
    cfa: formatMonthlyPrice('CFA'),
    gmd: formatMonthlyPrice('GMD'),
  };
};

